import { dialog, InfiniteScroll, InputFactory, Progress } from "nq-component";
import BaseListPage from "../../../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import CardView from "../../../../components/common/CardView";
import Search from "../../../../components/Search";
import withRouter from "../../../../withRouter";
import { SubmitFormBaseList } from "../../../../components/common/Converter";
import Pagination from "../../../../components/common/Pagination";
import AvailableTrainingPagePresenter from "./AvailableTrainingPagePresenter";
import { Spin } from "antd";

class AvailableTrainingPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new AvailableTrainingPagePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      progress: false,
      objects: [],
      currentPage: 1,
      perPage: 10,
      loading: true,
    };
  }

  async componentDidMount() {
    // await this.presenter.componentDidMount();
    this.loadObjects();
  }

  async getcurrent() {
    return await findObjectUseCase().execute("employees", {
      where: { id: this.getCurrentUser().employee.id },
    });
  }

  getUser() {
    return this.getCurrentUser();
  }

  async loadObjects() {
    const user = this.getCurrentUser();
    console.warn("USR: ", user);
    const employees = await findObjectUseCase().execute("employees", {
      where: { id: user.employee.id },
    });
    console.log("employees: ", employees);

    const employee = employees[0]; // Assuming you need the first employee object

    // Check if `region`, `office`, `division`, `section`, `unit`, and `cluster` have values
    const fields = [
      "region",
      "office",
      "division",
      "section",
      "unit",
      "cluster",
    ];
    // If any field is missing, default to using `region`
    let result;
    let index;

    fields.forEach((field, i) => {
      if (employee[field] && employee[field] !== "") {
        result = employee[field];
        index = i;
      }
    });

    console.log("Resulting data: ", result);

    console.log("INDE: ", index);

    const objectOrg = [
      "selectedRegions",
      "selectedOffices",
      "selectedDivisions",
      "selectedSections",
      "selectedUnits",
      "selectedPlantilla",
    ];
    console.warn("USER: ", user);
    try {
      let query;
      for (const role of user.roles) {
        if (role.id === "user") {
          query = {
            where: {
              $or: [
                { [objectOrg[index]]: result },
                { selectAllEmployee: true },
              ],
            },
            sort: {
              createdAt: 1,
            },
          };
        } else {
          query = {
            where: {
              // [objectOrg[index]]: result,
            },
            sort: {
              createdAt: -1,
            },
          };
        }
      }
      const objects = await findObjectUseCase().execute(
        this.getCollectionName(),
        query
      );
      this.setState({
        objects,
      });
    } catch (error) {
      this.showError("Trainig Error: ", error);
    } finally {
      this.setState({ loading: false });
    }
  }

  getCollectionName() {
    return "management_training";
  }

  async handleEnrollBtn(object) {
    try {
      const [allTraining, myTrainingData] = await Promise.all([
        findObjectUseCase().execute("management_training"),
        findObjectUseCase().execute("enrollees"),
      ]);

      const training = allTraining.find((item) => item.id === object.id);
      if (!training) {
        console.error("Training not found");
        return;
      }

      const user = this.getCurrentUser();
      const employeeId = user.employee.id;

      const employees = await findObjectUseCase().execute("employees");
      const employee = employees.find((emp) => emp.id === employeeId);

      if (!employee) {
        console.error("Employee not found");
        return;
      }

      const dataToUpsert = {
        trainingID: object.id,
        training: object.training,
        targetcompetency: training?.targetcompetency,
        stats: "Enroll",
        budgets: object.budgets,
        costs: object.costs,
        date: object.date,
        datefrom: object.datefrom,
        dateto: object.dateto,
        time: object.time,
        trainingMethod: object.trainingMethod,
        Firstname: employee.Firstname,
        Middlename: employee.Middlename,
        surname: employee.surname,
        email: employee.email,
        empID: employeeId,
      };

      const updatedTraining = { ...training };
      const count = {
        id: object.id,
        participants: updatedTraining.participants
          ? updatedTraining.participants + 1
          : 1,
      };

      const existingTraining = myTrainingData.find(
        (item) =>
          item.empID === employeeId &&
          item.trainingID === dataToUpsert.trainingID // Changed condition
      );

      if (existingTraining) {
        this.showError("You are already enrolled in this training!");
      } else {
        await upsertUseCase().execute("enrollees", dataToUpsert);
        await upsertUseCase().execute("attendees", dataToUpsert);

        this.showSuccess("You are now enrolled in this training");
        console.log("Enrollment success");

        // Update the training participant count in the "management_training" collection
        await upsertUseCase().execute("management_training", count);
        console.log("Participant count updated");
      }
    } catch (error) {
      console.error(
        "An error occurred while handling enroll button click:",
        error
      );
    }
  }

  handlePrintBtn(training) {
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";
    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(
      `<html><head><title>Print DTR</title><style>
          body {
            font-family: Arial, sans-serif;
            padding: 2rem;
          }
          .print-content-container {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
          }
          .print-content {
            width: 100%;
            margin: 5rem;
            padding: 10px;
          }
          .imgContent{
          display: flex;
          gap: 5rem
          }
          
          @page {
            size: auto;   /* auto is the initial value */
            margin: 0; /* this affects the margin in the printer settings */
          }
        </style>
        </head>
        <body>
        <div>${training?.trainingDetails}</div>
        <h6 class="mt-5"><b>Attachment: </b></h6>
        <div style="display: grid; margin: 2rem">
          ${
            training?.trainingsignature?.length > 0
              ? `
            <span><b>Training Signature:</b></span>
            <div class="imgContent">
              ${training?.trainingsignature
                .map(
                  (item) => `
                <img
                  src="${item}"
                  width="300"
                  height="250"
                  alt="Training Signature"
                />
              `
                )
                .join("")}
            </div>`
              : ""
          }
          ${
            training?.trainingcollateral?.length > 0
              ? `
            <span><b>Training Collateral:</b></span>
            <div class="imgContent">
              ${training?.trainingcollateral
                .map(
                  (item) => `
                  <img
                  src="${item}"
                  width="300"
                  height="250"
                  alt="Training Collateral"
                  />
                  `
                )
                .join("")}
                  </div>`
              : ""
          }
                  
                  ${
                    training?.trainingdocuments?.length > 0
                      ? `
                    <span><b>Training Documents:</b></span>
                    <div class="imgContent">
                      ${training?.trainingdocuments
                        .map(
                          (item) => `
                        <img
                          src="${item}"
                          width="300"
                          height="250"
                          alt="Training Signature"
                        />
                      `
                        )
                        .join("")}
                    </div>`
                      : ""
                  }
        </div>
        <script>
          window.onload = function() {
            window.focus();
            window.print();
            window.onafterprint = function() {
              document.body.removeChild(iframe);
            };
          };
        </script>
        </body></html>`
    );
    iframeDoc.close();
  }

  async handleViewBtn(object) {
    const allTraining = await findObjectUseCase().execute(
      "management_training"
    );
    const training = allTraining.find((item) => item.id === object.id);

    console.log("training", training);
    dialog.fire({
      html: (
        <>
          <div className="d-block p-3">
            {/* <p>{training?.trainingDetails}</p> */}
            <div
              // style={editorStyle}
              dangerouslySetInnerHTML={{ __html: training?.trainingDetails }} // Render HTML content
            />
            <h6 className="mt-5">
              <b>Attachment: </b>
            </h6>
            <div className="d-grid gap-3 mb-4">
              {Array.isArray(training?.trainingsignature) &&
                training?.trainingsignature?.length > 0 && (
                  <span>
                    <b>Training Signature:</b>
                  </span>
                )}
              <div className="d-flex gap-4">
                {Array.isArray(training?.trainingsignature) &&
                  training?.trainingsignature?.map((item, index) => (
                    <img
                      key={index}
                      src={item}
                      width={100}
                      height={100}
                      alt="Training Signature"
                    />
                  ))}
              </div>
              {Array.isArray(training?.trainingcollateral) &&
                training?.trainingcollateral?.length > 0 && (
                  <span>
                    <b>Training Collateral:</b>
                  </span>
                )}
              <div className="d-flex gap-4">
                {Array.isArray(training?.trainingcollateral) &&
                  training?.trainingcollateral?.map((item) => (
                    <img
                      src={item}
                      width={100}
                      height={100}
                      alt="Training Collateral"
                    />
                  ))}
              </div>
              {Array.isArray(training?.trainingdocuments) &&
                training?.trainingdocuments?.length > 0 && (
                  <span>
                    <b>Training Documents:</b>
                  </span>
                )}
              <div className="d-flex gap-4">
                {Array.isArray(training?.trainingdocuments) &&
                  training?.trainingdocuments?.map((item, index) => (
                    <img
                      key={index}
                      src={item}
                      width={100}
                      height={100}
                      alt="Training Documents"
                    />
                  ))}
              </div>
            </div>
          </div>
          <div className="d-flex gap-2 justify-content-end border-top p-3">
            <button className="btn btn-light" onClick={() => dialog.close()}>
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={() => this.handlePrintBtn(training)}
            >
              Print
            </button>
          </div>
        </>
      ),
      footer: false,
    });
  }

  handlePageChange = (currentPage) => {
    this.setState({ currentPage });
  };

  handlePerPageChange = (perPage) => {
    this.setState({
      perPage,
      currentPage: 1,
    });
  };

  async searchSubmit(where) {
    const objects = await findObjectUseCase().execute(
      this.getCollectionName(),
      {
        where: where.$or[1],
        sort: { createdAt: -1 },
      }
    );
    this.setState({ objects });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, currentPage, perPage, loading } = this.state;
    console.log("LOADING: ", loading);

    // console.warn("OBEEEEEE: ", objects);
    if (!schema) return <Progress />;

    const startIndex = (currentPage - 1) * perPage;
    const paginatedObjects = objects.slice(startIndex, startIndex + perPage);

    return (
      <>
        <div className="overflow-auto">
          <InfiniteScroll className="h-100" loadMore={this.loadMore.bind(this)}>
            <div className="p-0">
              <CardView style={{ borderRadius: 0 }}>
                <Search
                  schemas={this.getSchemas()}
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                />
                {/* <InputFactory
                  type="String"
                  onChange={this.searchSubmit.bind(this)}
                /> */}
              </CardView>
              <hr />
              {loading ? (
                <div className="d-flex align-items-center justify-content-center p-5">
                  <Spin size="large" />
                </div>
              ) : (
                <div className="mt-4 row w-100 p-0 m-0 d-flex align-items-center justify-content-center">
                  {paginatedObjects.map((items, index) => {
                    return (
                      <div className="col-lg-4 mb-5" key={index}>
                        <CardView style={{ borderRadius: 0 }}>
                          <p>
                            <b>{items.training}</b>
                          </p>
                          <div
                            className="d-grid"
                            style={{
                              color: "rgba(0, 0, 0, .45)",
                              fontSize: "12px",
                            }}
                          >
                            <span>
                              <i className="bi bi-calendar" /> {items.date}
                            </span>
                            <span>
                              <i className="bi bi-clock" /> {items.time}
                            </span>
                            <span>
                              Date of submission{" "}
                              <i className="bi bi-calendar" /> -
                            </span>
                            <span>
                              Target Competency: test: {items.targetcompetency}
                            </span>
                          </div>
                          <hr />
                          <div className="d-flex align-items-center justify-content-evenly">
                            <div
                              className="w-50 border-end text-center "
                              style={{ cursor: "pointer" }}
                              onClick={() => this.presenter.verification(items)}
                            >
                              <i className="bi bi-journal text-bg-secondary" />
                            </div>
                            <div
                              className="w-50 border-start text-center"
                              style={{ cursor: "pointer" }}
                              onClick={() => this.handleViewBtn(items)}
                            >
                              <i className="bi bi-search text-bg-secondary" />
                            </div>
                          </div>
                        </CardView>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </InfiniteScroll>
        </div>
        <Pagination
          totalObjects={objects.length}
          onPageChange={this.handlePageChange}
          onPerPageChange={this.handlePerPageChange}
        />
      </>
    );
  }
}

export default withRouter(AvailableTrainingPage);
